<template>
  <section>
    <div class="d-flex justify-content-between px-0 pt-25">
      <b-button
        v-if="PlatformAccessManager.canAddTranslationKeys()"
        v-b-modal.modal-add-translationKey
        variant="primary"
        :disabled="isLoading"
        size="sm"
      >
        <GjIcon
          class="mr-50"
          name="Plus"
        />
        {{ $tk('ClientPortal.Admin.AddTranslationKey') }}
      </b-button>
      <SearchInputField
        :disabled="isLoading"
        class="ml-auto"
        :placeholder="$tk('Admin.Languages.SearchByResourceName')"
        @onInputSearch="onSearchChange"
      />
    </div>
    <b-skeleton-table
      v-if="isLoading"
      :rows="10"
      :columns="3"
    />
    <b-card
      v-else
      class="my-50 admin-table--smaller"
      no-body
    >
      <Table
        :data="translated"
        :columns="columns"
        :is-loading="isLoading"
        class="admin-table__data"
        type-of-table="translateLanguages"
        @changePage="changeCurrentPage"
      />
    </b-card>
    <b-modal
      id="modal-add-translationKey"
      :ok-title="$tk('ClientPortal.Form.Actions.Add')"
      :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
      centered
      cancel-variant="outline-secondary"
      size="md"
      :title="$tk('ClientPortal.Admin.AddTranslationKey')"
      no-enforce-focus
      :ok-disabled="!translationKey"
      @change="resetTranslationKey"
      @ok="save"
    >
      <b-form-group
        :label="$tk('ClientPortal.Form.TranslationKey')+ ' *'"
        label-size="xs"
        class="mb-0"
      >
        <b-form-input
          v-model="translationKey"
          size="sm"
          type="text"
          :placeholder="$tk('ClientPortal.Form.TranslationKeyPlaceholder')"
        />
      </b-form-group>
    </b-modal>
  </section>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'
import Table from '@/components/Table.vue'
import SearchInputField from '@/components/SearchInputField.vue'
import notification from '@/mixins/toastification'
import store from '@/store'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import LanguageService from '@/api/client/language.service'
import { PlatformAccessManager } from '@/utils/accessManager/accessManager'
import translation from '@/mixins/translate'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    SearchInputField,
    Table,
    GjIcon,
  },
  mixins: [notification],
  setup(_, context) {
    const isLoading = ref(false)
    const translated = computed(() => store.getters.getlanguagesResources)
    const columns = ref()
    const model = computed(() => store.getters.getlanguagesModel)
    const { id } = context.root.$route.params
    const translationKey = ref('')

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('translate', { id })
      columns.value = translated.value.columns
      columns.value[0].label = translation.methods.$tk('ClientPortal.Admin.Languages.ResourceName')
      isLoading.value = false
    })

    const changeCurrentPage = async value => {
      model.value.serverParams.page = value
      await store.dispatch('translate', { id, filter: model.value.serverParams })
    }

    const onSearchChange = async value => {
      model.value.serverParams.name = value
      if (!value) { await store.dispatch('translate', { id, filter: model.value.serverParams }) }
      await store.dispatch('translate', { id, filter: model.value.serverParams })
    }

    const save = async () => {
      let response = {}
      try {
        response = await LanguageService.createResource(translationKey.value)
        if (response.saved) {
          notification.methods.success(response.message)
        } else {
          notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
      }
    }

    const resetTranslationKey = () => {
      translationKey.value = ''
    }

    return {
      isLoading,
      translated,
      changeCurrentPage,
      onSearchChange,
      columns,
      translationKey,
      resetTranslationKey,
      save,
      PlatformAccessManager,
    }
  },
}
</script>
